export default "__VITE_ASSET__CXs7bF$K__"